module.exports = __webpack_public_path__ + "img/person-snowboarding.87531649.svg";